import React from 'react';

import Header from './Header';
import Footer from './Footer';

import './About.css';

const headerNum = Math.round(Math.random() + 1);

class About extends React.Component {
  render() {
    return (
      <div className="App">
        <Header currentPage={this.props.currentPage} pages={this.props.pageData} />
        <div className="App__divider"></div>
        <img src={`../header-${headerNum}.jpg`} className="img-header" />
        <div className="row text-left about__container">
          <div className="small-12 columns">
            <h2>About</h2>

            <p>I am a multi-disciplinary artist working primarily on large scale, site-specific, geometric art.</p>

            <p>In both private and commercial commissions, my work uses pattern, repetition and abstraction to explore the concepts of perceived reality and illusion, and the complex relationship between technology and nature.</p>

            <p>I’ve been fascinated with science and robotics since I was a little boy and the systematic rhythms of mechanics and engineering are huge influences on my designs. Starting out in printmaking, then progressing through 2D animation on to 3D modelling and more recently perspective anamorphosis and Trompe L’oeil, the relationship between form, structure and perception is a constant theme within my work and repeatedly challenges and shapes my working process.</p>

            <p>By restricting my art to horizontal or vertical straight lines, curved edges and 45-degree angles I am forced to expand and test my creativity, iterate within my design process, to create seemingly simple windows onto wider complex forms.</p>

            <p>I continually take inspiration from the strained relationship between nature and technology and the various ways in which we can manipulate our perception. These themes seem ever more relevant in our current world and I will continue to reflect these conflicts as my work and processes develop.</p>

            <p>In both science and nature, I am in awe of the complex within the simple and strive to reflect this in everything I do. </p>

            <p>“Simplicity is the ultimate sophistication” <br />Leonardo Da Vinci</p>
          </div>
        </div>
        <Footer blogInfo={this.props.blogInfo} />
      </div>
      
    )
  }
}

export default About;


// WEBPACK FOOTER //
// ./src/components/About.js